import { render, staticRenderFns } from "./SpecieEdit.vue?vue&type=template&id=0daa386b&"
import script from "./SpecieEdit.vue?vue&type=script&lang=js&"
export * from "./SpecieEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports